import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PageTitle from "../XoSoCompound/PageTitle";
import DateFilter from "./DateFilter";
import ResultCard from "./ResultCard";
import useDienToan6x36 from "./useDienToan6x36";
import { TITLE, TZ, drawDateKey } from "./constants";
import "../XoSoCompound/XoSoCompound.css";
import "./DienToan6x36.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function DienToan6x36({ title, showTitle = false, defaultDate, dataDefault, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || dataDefault || config?.date || null);
  const { results, loading, resolvedDate } = useDienToan6x36(date);
  const selectedDate = date || resolvedDate || today;
  const hasSelected = results.some((item) => drawDateKey(item.drawDate) === selectedDate);

  return (
    <div className="xoso-compound dientoan6x36">
      {showTitle ? <PageTitle>{title || TITLE}</PageTitle> : null}

      <DateFilter value={selectedDate} onChange={setDate} maxDate={today} />

      <div className={`dt636-stack${loading ? " is-loading" : ""}`}>
        {loading ? <div className="dt636-stack__spinner" /> : null}
        {!loading && !hasSelected ? (
          <div className="dt636-card">
            <div className="xoso-kqxs__empty">
              Không có dữ liệu ngày {dayjs(selectedDate).format("DD/MM/YYYY")}
            </div>
          </div>
        ) : null}
        {results.map((item) => (
          <ResultCard key={item.id || item.drawDate} result={item} />
        ))}
      </div>
    </div>
  );
}

DienToan6x36.PageTitle = PageTitle;
DienToan6x36.DateFilter = DateFilter;
DienToan6x36.ResultCard = ResultCard;

export { PageTitle, DateFilter, ResultCard };
export default DienToan6x36;
